import { UIDatePickerAdapter } from './date-picker.adapter';
import _moment from 'moment';
import { Moment } from 'moment';
import { Injectable } from '@angular/core';

const moment = _moment;

@Injectable()
export class UIDatePickerAdapterMoment extends UIDatePickerAdapter<Moment> {
  fromMilliseconds(milliseconds: number): Moment {
    return moment(milliseconds);
  }

  toMilliseconds(value: Moment | null): number | null {
    return value ? value.valueOf() : undefined;
  }
}
